import { KeyValue } from "@/main/models/common";
import { AffectedTypeActionTypes, AffectedTypeTypes } from "./affectedTypeTypes";

export function getAffectedType(): AffectedTypeActionTypes {
	return {
		type: AffectedTypeTypes.GET_AFFECTED_TYPE,
	};
}

export function saveAffectedType(
	data: KeyValue[] | null,
	isError: boolean,
	errorMessages: string[] | null,
): AffectedTypeActionTypes {
	return {
		type: AffectedTypeTypes.SAVE_AFFECTED_TYPE,
		payload: { data, isError, errorMessages },
	};
}

export function resetReducerAffectedType(): AffectedTypeActionTypes {
	return {
		type: AffectedTypeTypes.RESET_REDUCER_AFFECTED_TYPE,
	};
}
